(function () {
  function init(root) {
    if (root.dataset.collectorReady) return;
    root.dataset.collectorReady = 'true';
    var tiles = Array.prototype.slice.call(root.querySelectorAll('.vwh__tile'));
    var spines = Array.prototype.slice.call(root.querySelectorAll('.vwh__shelf-book'));
    var order = [];
    var cleanups = [];
    var shelf = root.querySelector('[data-collector-shelf]');
    var physics = window.ViewsCollectorStack && window.ViewsCollectorStack(spines.map(function (spine) {
      return { id: spine.getAttribute('data-num'), thickness: parseFloat(spine.getAttribute('data-spine-ratio')) || .03 };
    }));
    var gravityMotion = window.matchMedia('(prefers-reduced-motion: no-preference)');
    var lastIntent = 0, stackFrame = 0, lastFrameTime = 0, destroyed = false;
    function paintStack() {
      if (!physics) return;
      var airborne;
      spines.forEach(function (spine) {
        var b = physics.bodies[spine.getAttribute('data-num')];
        var moving = b.on && physics.isRunning();
        spine.classList.toggle('is-simulated', moving);
        spine.classList.toggle('is-waiting', moving && b.pending);
        spine.classList.toggle('is-falling', moving && (!b.contacted || b.gap > .001 || Math.abs(b.angle) > .0015));
        if (moving) {
          spine.style.setProperty('--shelf-y', b.y.toFixed(6));
          spine.style.setProperty('--shelf-angle', b.angle.toFixed(6) + 'rad');
        } else {
          spine.style.removeProperty('--shelf-y');
          spine.style.removeProperty('--shelf-angle');
        }
        if (moving && !b.pending && !b.contacted) airborne = b;
      });
      if (shelf) {
        shelf.style.setProperty('--landing-opacity', airborne ? String(.2 * Math.max(0, 1 - airborne.gap / .32)) : '0');
        if (airborne) {
          var spine = spines.filter(function (item) { return item.getAttribute('data-num') === airborne.id; })[0];
          shelf.style.setProperty('--landing-offset', spine.style.getPropertyValue('--shelf-offset'));
          shelf.style.setProperty('--landing-level', String(order.indexOf(airborne.id) + 1));
          shelf.style.setProperty('--landing-scale', String(1 + airborne.gap * .45));
        }
      }
    }
    function stopStack() {
      if (stackFrame) window.cancelAnimationFrame(stackFrame);
      stackFrame = lastFrameTime = 0;
      if (physics) { physics.finish(); paintStack(); }
    }
    function frameStack(time) {
      stackFrame = 0;
      if (destroyed || !root.isConnected || document.hidden || !gravityMotion.matches) { stopStack(); return; }
      var dt = lastFrameTime ? (time - lastFrameTime) / 1000 : 1 / 60;
      lastFrameTime = time;
      var active = physics.step(dt);
      paintStack();
      if (active) stackFrame = window.requestAnimationFrame(frameStack);
      else lastFrameTime = 0;
    }
    function recordIntent(event) {
      if (event.target.closest && event.target.closest('.vwh__tile')) lastIntent = Date.now();
    }
    function visibilityChange() { if (document.hidden) stopStack(); }
    function motionChange() { if (!gravityMotion.matches) stopStack(); }
    root.addEventListener('click', recordIntent, true);
    document.addEventListener('visibilitychange', visibilityChange);
    if (gravityMotion.addEventListener) gravityMotion.addEventListener('change', motionChange);
    cleanups.push(function () {
      stopStack();
      root.removeEventListener('click', recordIntent, true);
      document.removeEventListener('visibilitychange', visibilityChange);
      if (gravityMotion.removeEventListener) gravityMotion.removeEventListener('change', motionChange);
    });
    var motion = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
    function sync() {
      var selected = tiles.filter(function (t) { return t.getAttribute('aria-pressed') === 'true'; }).map(function (t) { return t.getAttribute('data-num'); });
      order = order.filter(function (n) { return selected.indexOf(n) !== -1; });
      selected.forEach(function (n) { if (order.indexOf(n) === -1) order.push(n); });
      var offset = 0;
      order.forEach(function (num) {
        var spine = spines.filter(function (item) { return item.getAttribute('data-num') === num; })[0];
        if (!spine) return;
        spine.style.setProperty('--shelf-offset', String(offset));
        offset += parseFloat(spine.getAttribute('data-spine-ratio')) || .03;
      });
      spines.forEach(function (spine, i) {
        var level = order.indexOf(spine.getAttribute('data-num'));
        if (level >= 0) spine.style.setProperty('--shelf-level', String(level));
        spine.style.setProperty('--shelf-shift', [0, .4, -.2, .7, -.3][i % 5] + 'px');
        spine.classList.toggle('is-on', level >= 0);
        spine.classList.toggle('is-top', level >= 0 && level === order.length - 1);
      });
      if (physics) {
        var animate = gravityMotion.matches && !document.hidden && root.classList.contains('collector-in-view') && Date.now() - lastIntent < 1800;
        physics.set(order, animate);
        paintStack();
        if (physics.isRunning() && !stackFrame) stackFrame = window.requestAnimationFrame(frameStack);
        if (!physics.isRunning()) stopStack();
      }
    }
    tiles.forEach(function (tile) {
      var book = tile.querySelector('.vwh__book');
      if (!book) return;
      var frame = 0;
      var pointer;
      function reset() {
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        book.style.removeProperty('--book-rx');
        book.style.removeProperty('--book-ry');
        book.style.removeProperty('--book-light');
      }
      function move(event) {
        if (!motion.matches || event.pointerType !== 'mouse' || tile.getAttribute('aria-pressed') !== 'true') return;
        pointer = { x: event.clientX, y: event.clientY };
        if (frame) return;
        frame = window.requestAnimationFrame(function () {
          frame = 0;
          if (!tile.isConnected || !motion.matches || tile.getAttribute('aria-pressed') !== 'true') return;
          var rect = tile.getBoundingClientRect();
          var x = Math.max(-1, Math.min(1, (pointer.x - rect.left) / rect.width * 2 - 1));
          var y = Math.max(-1, Math.min(1, (pointer.y - rect.top) / rect.height * 2 - 1));
          book.style.setProperty('--book-rx', (-y * 2.5).toFixed(2) + 'deg');
          book.style.setProperty('--book-ry', (x * 3).toFixed(2) + 'deg');
          book.style.setProperty('--book-light', (50 + x * 28).toFixed(1) + '%');
        });
      }
      tile.addEventListener('pointermove', move);
      tile.addEventListener('pointerleave', reset);
      tile.addEventListener('blur', reset);
      tile.addEventListener('click', reset);
      cleanups.push(function () {
        reset();
        tile.removeEventListener('pointermove', move);
        tile.removeEventListener('pointerleave', reset);
        tile.removeEventListener('blur', reset);
        tile.removeEventListener('click', reset);
      });
    });
    var visibility;
    if (window.IntersectionObserver) {
      visibility = new IntersectionObserver(function (entries) {
        root.classList.toggle('collector-in-view', entries[0].isIntersecting);
        if (!entries[0].isIntersecting) stopStack();
      }, { threshold: 0 });
      visibility.observe(root);
    } else {
      root.classList.add('collector-in-view');
    }
    var observer = new MutationObserver(sync);
    observer.observe(root, { attributes: true, subtree: true, attributeFilter: ['aria-pressed'] });
    sync();
    root.addEventListener('collector:destroy', function () {
      destroyed = true;
      observer.disconnect();
      if (visibility) visibility.disconnect();
      root.classList.remove('collector-in-view');
      cleanups.forEach(function (cleanup) { cleanup(); });
      delete root.dataset.collectorReady;
    }, { once: true });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('[data-collector]')) init(scope);
    scope.querySelectorAll('[data-collector]').forEach(init);
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-collector]').forEach(function (root) { root.dispatchEvent(new Event('collector:destroy')); });
  });
})();
